/**
 * 业务提醒类型枚举
 */
export enum BusinessReminderType {
  /** 询价 */
  INQUIRY = 1,
  /** 报价 */
  QUOTATION = 2,
  /** 订单 */
  ORDER = 3,
}

/**
 * 业务类型到路由的映射（一对多）
 * 一个业务类型可以对应多个路由（当前都是一对一，预留扩展能力）
 */
export const BusinessTypeToRoutesMap: Record<BusinessReminderType, string[]> = {
  [BusinessReminderType.INQUIRY]: ['SaasInquiryManagement'],
  [BusinessReminderType.QUOTATION]: ['SaasQuotationManagement'],
  [BusinessReminderType.ORDER]: ['OrderManagement']
}

/**
 * 路由到业务类型的映射（一对多）
 * 一个路由可以对应多个业务类型（当前都是一对一，预留扩展能力）
 */
export const RouteToBusinessTypesMap: Record<string, BusinessReminderType[]> = {
  'SaasInquiryManagement': [BusinessReminderType.INQUIRY],
  'SaasQuotationManagement': [BusinessReminderType.QUOTATION],
  'OrderManagement': [BusinessReminderType.ORDER]
}

/**
 * 辅助方法：根据路由名称获取业务类型列表
 * @param routeName 路由名称
 * @returns 业务类型数组
 */
export function getBusinessTypesByRoute(routeName: string): BusinessReminderType[] {
  return RouteToBusinessTypesMap[routeName] || []
}

/**
 * 辅助方法：根据业务类型获取路由名称列表
 * @param businessType 业务类型
 * @returns 路由名称数组
 */
export function getRoutesByBusinessType(businessType: BusinessReminderType): string[] {
  return BusinessTypeToRoutesMap[businessType] || []
}

/**
 * 辅助方法：判断路由是否关联了业务提醒
 * @param routeName 路由名称
 * @returns 是否关联
 */
export function hasBusinessReminder(routeName: string): boolean {
  return routeName in RouteToBusinessTypesMap
}
